import cx from 'classnames';
import Proptypes from 'prop-types';

import { LINK_DEFINITIONS } from '@xing-com/content-editor-plugin-helpers';

import { LINK_TAG_NAME } from './constants';
import styles from './Link.css';

const renderer = ({
  node: { type, data },
  URL_SELF = '',
  LINK_TAG = LINK_TAG_NAME,
  nofollow,
  className,
  ...attributes
}) => {
  if (type === LINK_DEFINITIONS.type) {
    let target = '_blank';
    let _nofollow = nofollow;
    if (nofollow === undefined) {
      _nofollow = true;
    }
    if (URL_SELF !== '' && data.href.includes(URL_SELF)) {
      target = '_self';
      if (nofollow === undefined) {
        _nofollow = false;
      }
    }
    const {
      nodeAttributes: { children },
      renderers,
      ...restOfAttributes
    } = attributes;
    if (_nofollow) {
      restOfAttributes.rel = 'nofollow';
    }

    return (
      <LINK_TAG
        {...restOfAttributes}
        className={cx(styles.link, className)}
        href={data.href}
        target={target}
      >
        {children}
      </LINK_TAG>
    );
  }
};

renderer.proptypes = {
  node: Proptypes.object,
  attributes: Proptypes.object,
  className: Proptypes.string,
  LINK_TAG: Proptypes.node,
  nofollow: Proptypes.bool,
};

export { renderer };
